// extracted by mini-css-extract-plugin
export default {"superAdminHeader":"header_superAdminHeader__H30mO"};